import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer>
      <p>Sujan Raj Shrestha</p>
      <Link to="/about">About</Link>
    </footer>
  );
};

export default Footer;
